/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import AuditComponent from '../components/AuditComponent'
import { connect } from 'react-redux'
import { auditActions } from '../_actions'

import PropTypes from 'prop-types'

import { getLoader } from '../_common/utils'


function AuditContainer({ auditList, getAuditsByPage, totalRecords, isGetAllError, isAuditLoading, getAudit, activeData, clearAllMessages, auditLog }) {
  return (
    <div className="p-grid pageWrapper">
      {isAuditLoading ? getLoader() : ''}
      <AuditComponent
        getAuditsByPage={getAuditsByPage}
        totalRecords={totalRecords}
        auditList={auditList}
        getAudit={getAudit}
        activeData={activeData}
        auditLog={auditLog}
      />
    </div>
  )
}

AuditContainer.propTypes = {
  auditList: PropTypes.array,
  getAuditsByPage: PropTypes.func,
  totalRecords: PropTypes.number,
  isGetAllError: PropTypes.bool,
  isAuditLoading: PropTypes.bool,
  activeData: PropTypes.object,
  clearAllMessages: PropTypes.func,
  auditLog: PropTypes.object
}
const mapStateToProps = state => {
  return {
    auditList: state.audits.auditList ? state.audits.auditList : [],
    totalRecords: state.audits.count,
    isGetAllError: state.audits.isGetAllError,
    isAuditLoading: state.audits.isLoading,
    activeData: state.audits.activeData ? state.audits.activeData : {},
    auditLog: state.audits

  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getAuditsByPage: (start, pageSize, search) => dispatch(auditActions.getAuditsByPage(start, pageSize, search)),
    getAudit: (id) => dispatch(auditActions.getAuditById(id)),
    clearAllMessages: () => dispatch(auditActions.clearAllMessages())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuditContainer)
